// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"d13bf505216111a2","3756":"01e41b3a9ca70d16","4316":"da7517a88118b074","9839":"12c9392b4199081f"}[chunkId] + ".js";
};